import { FC } from "react";

export const Separator: FC = () => (
  <div
    style={{
      minHeight: "1px",
      margin: "10%",
      background: "#fbf5e1",
    }}
  ></div>
);
